import {Directive, TemplateRef} from "@angular/core";
import {DxPageHeaderBaseDirective} from "./dx-page-header-base.directive";

/**
 * Структурная директива для переопределения шаблона области под раздел выхода из системы в шапке.
 * @publicApi
 */
@Directive({selector: '[dxPageHeaderLogoutBar]'})
export class DxPageHeaderLogoutBarDirective extends DxPageHeaderBaseDirective {
  constructor(public template: TemplateRef<any>) {
    super();
  }
}
